var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { SubAPI } from "./SubAPI";
export class Products extends SubAPI {
    list(input) { return this.fetcher.get("/api/products", input); }
    makeChildrenOf(props) { return this.fetcher.post("/api/product/make-children-of", props); }
    discontinuedForProject(input) { return this.fetcher.get("/api/product/discontinued-for-project", input); }
    dynamicErrors(input) { return this.fetcher.get("/api/product/dynamic-errors", input); }
    relatedFiles(input) { return this.fetcher.get("/api/products/related-files", input); }
    search(input, canceler) {
        return __awaiter(this, void 0, void 0, function* () { const search = new URLSearchParams(); for (let k in input) {
            const v = input[k];
            if (v) {
                search.set(k, v.toString());
            }
        } const res = yield this.fetcher.fetch("/api/products/search?" + search, { method: "GET", signal: canceler === null || canceler === void 0 ? void 0 : canceler.signal }); return this.fetcher.handleFetchResponse(res); });
    }
    searchSignal(input) { return this.fetcher.post("/api/products/search-signal", input); }
    categories(input) { return this.fetcher.get("/api/product/categories", input); }
    upsert(input) { return this.fetcher.post("/api/product", input); }
    upsertWithTask(input) { return this.fetcher.post("/api/product/with-task", input); }
    triggerProjectRecalc(input) { return this.fetcher.post("/api/product/trigger-project-recalc", input); }
    stockingOptions(input) { return this.fetcher.get("/api/product/stocking-options", input); }
    upload(props) { return this.fetcher.postFormData("/api/div-10/set-cut-sheet", { file: props.file, info: JSON.stringify({ id: props.id }) }); }
    listById(input) { return this.fetcher.post("/api/products", input); }
    getById(id) { return this.listById({ ids: [id] }).then(v => v[0]); }
    getFinishNameForCode(input) { return this.fetcher.get("/api/product/finish-name", input); }
    buildDoorSpec(input) { return this.fetcher.post("/api/product/door-spec", input); }
    buildFrameSpec(input) { return this.fetcher.post("/api/product/frame-spec", input); }
    listMeta(input) { return this.fetcher.get("/api/product-meta/list", input); }
    listProjectUsage(input) { return this.fetcher.get("/api/product/list-project-usage", input); }
    forSpec(input) { return this.fetcher.post("/api/product/for-spec", input); }
    listScripts(input) { return this.fetcher.get("/api/product/scripts", input); }
    checkScript(input) { return this.fetcher.post("/api/product/script/check", input); }
    listFinishes(input) { return this.fetcher.get("/api/product/finishes", input); }
    updateFinish(input) { return this.fetcher.post("/api/product/finish", input); }
    listSummaryForProjectRecalc(input) { return this.fetcher.get("/api/product/recalc-summary/for-project", input); }
    listForProjectRecalc(input) { return this.fetcher.get("/api/product/recalc-items/for-project", input); }
    recalcForProject(input) { return this.fetcher.post("/api/product/recalc-items/for-project", input); }
    listRecalcHistory(input) { return this.fetcher.get("/api/product/recalc-history", input); }
    listRecalcPriceChanges(input) { return this.fetcher.get("/api/product/recalc-history/prices", input); }
    listRecalcProductChanges(input) { return this.fetcher.get("/api/product/recalc-history/products", input); }
    listRecalcOpenings(input) { return this.fetcher.get("/api/product/recalc-history/openings", input); }
}
export function fixFinishName(name) { if (name === "N/A")
    return ""; return name; }
